import React from 'react';

const Forbidden: React.FC = () => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100vh',
                textAlign: 'center',
                padding: '2rem',
                paddingTop: '25vh',
            }}
        >
            <h1 style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🚫 403 - Access Denied</h1>
            <p style={{ fontSize: '1.25rem' }}>
                Sorry, you do not have permission to access this application.
            </p>
        </div>
    );
};

export default Forbidden;
